export const gatewayConfig = {
  SYSTEMS_SERVICE,
  COMPANIES_SERVICE,
  GEO_SERVICE,
  AUDIT_SERVICE,
  MAIL_SERVICE,
  USER_SERVICE,
  CREATIVITY_SERVICE,
  CAMPAIGN_SERVICE,
  PLANNER_SERVICE,
  CATALOG_SERVICE,
  PRODUCT_SERVICE,
  NEGOTIATION_SERVICE,
  CIRCUITS_SERVICE,
  SHARE_SERVICE,
  ORDER_SERVICE,
  FRAME_SERVICE,
  OPPORTUNITY_SERVICE,
  ADVERTISER_SERVICE,
  DEVICE_SERVICE,
  SCHEDULER_SERVICE,
  HISTORY_SERVICE,
  CDN_SERVICE,
  QUOTE_SERVICE,
  OTP_SERVICE,
  LICENSES_SERVICE,
}

function GEO_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev"
      apiVer = "v1";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function AUDIT_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      // apiUrl = "http://51.91.104.29:8094"
      apiUrl = "https://api-alessiplatform.codesour.dev"
      apiVer = "v1";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function HISTORY_SERVICE(ambience) {
  let apiUrl, apiVer, serviceName;
  switch (ambience) {
    case "dev":
      // apiUrl = "http://51.91.104.29:8094"
      apiUrl = "https://api-alessiplatform.codesour.dev"
      apiVer = "v1";
      serviceName = "/history"
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      apiVer = "v1";
      serviceName = "/history"
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      apiVer = "v1";
      serviceName = "/history"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer,
    serviceName
  }
}

function MAIL_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      // apiUrl = "http://51.91.104.29:8094"
      apiUrl = "https://api-alessiplatform.codesour.dev"
      apiVer = "v1";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function SYSTEMS_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev"
      // apiUrl = "http://192.168.1.43:8093"
      apiVer = "v1";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function FRAME_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev"
      apiVer = "v1";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function DEVICE_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev"
      apiVer = "v1";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function CIRCUITS_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev"
      apiVer = "v1";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function COMPANIES_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev/company"
      apiVer = "v1";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev/company"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it/company"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function CAMPAIGN_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev/"
      apiVer = "v1";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev/"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it/"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function PLANNER_SERVICE(ambience) {
  let apiUrl, apiVer
  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev/"
      apiVer = "v2";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev/"
      apiVer = "v2";
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it/"
      apiVer = "v2";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function USER_SERVICE(ambience) {
  let apiUrl
  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev"
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
  }
}

function CREATIVITY_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      //apiUrl = "http://develop.codesour.tech:8094"
      apiUrl = "https://api-alessiplatform.codesour.dev"
      //apiUrl = "https://api-alessiplatform.codesour.dev"
      apiVer = "v1";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      apiVer = "v1";
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      apiVer = "v1";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function CATALOG_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev/v1/estimate/catalog";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev/v1/estimate/catalog"
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it/v1/estimate/catalog"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function PRODUCT_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function ORDER_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}
function OPPORTUNITY_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev"
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function NEGOTIATION_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev/v1/negotiation/";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev/v1/negotiation/"
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it/v1/negotiation/"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}
function ADVERTISER_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev/v1/";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev/v1/"
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it/v1/"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function SHARE_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      // apiUrl = "http://localhost:8097/"
      apiUrl = "https://api-alessiplatform.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it/"
      apiVer = "v1"
      break;
    default:
  }

  return { apiUrl, apiVer }
}

function SCHEDULER_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev/"
      apiVer = "v1"
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev/"
      apiVer = "v1"
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it/"
      apiVer = "v1"
      break;
    default:
  }

  return {
    apiUrl,
    apiVer
  }
}

function CDN_SERVICE(ambience) {
  let CDNUrl

  switch (ambience) {
    case "dev":
      CDNUrl = "https://cdn.codesour.dev/codesour"
      break;
    case "stage":
      CDNUrl = "https://cdn.codesour.dev/codesour"
      break;
    case "prod":
      CDNUrl = "https://cdn.codesour.dev/codesour"
      break;
    default:
  }

  return {
    CDNUrl,
  }
}

function QUOTE_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev/v1/quote";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev/v1/quote"
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it/v1/quote"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function OTP_SERVICE(ambience) {
  let apiUrl, apiVer

  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev/v1/OTP";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev/v1/OTP"
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it/v1/OTP"
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}

function LICENSES_SERVICE(ambience) {
  let apiUrl, apiVer = "v2";

  switch (ambience) {
    case "dev":
      apiUrl = "https://api-alessiplatform.codesour.dev/" + apiVer + "/system/license";
      break;
    case "stage":
      apiUrl = "https://api-alessiplatform-stage.codesour.dev/" + apiVer + "/system/license";
      break;
    case "prod":
      apiUrl = "https://alessiplatform.it/v2/licences/" + apiVer + "/system/license";
      break;
    default:
      return null;
  }

  return {
    apiUrl,
    apiVer
  }
}